import React, { createContext, useMemo } from "react";
import { FilterStore } from "../createFilterStore";

interface FilterContextProps {
  filterStore: FilterStore;
}

export const FilterContext = createContext<FilterContextProps | undefined>(
  undefined,
);

export const FilterProvider = (
  props: React.PropsWithChildren<FilterContextProps>,
) => {
  const { children, filterStore } = props;

  const contextValue = useMemo(() => ({ filterStore }), [filterStore]);

  return (
    <FilterContext.Provider value={contextValue}>
      {children}
    </FilterContext.Provider>
  );
};
